import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class PaginationHelper extends BaseService {
  public getDefaultPageSize(): number {
    return 10;
  }
}
